import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const BANNER_NAME = 'starter-promotion-december-2025-banner';
export const StarterPromotionDecember2025Banner = ({
  trackBannerInteraction
}) => {
  useEffect(() => {
    trackBannerInteraction === null || trackBannerInteraction === void 0 || trackBannerInteraction({
      action: 'view',
      name: BANNER_NAME
    });
  }, [trackBannerInteraction]);
  return /*#__PURE__*/_jsx(Alert, {
    "data-test-id": BANNER_NAME,
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "starterPromotionDecember2025Banner.title"
    }),
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "starterPromotionDecember2025Banner.description"
    })
  });
};